import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { PayloadAction } from '@reduxjs/toolkit/dist/createAction';

const APP_BANNER_ENABLED_COOKIE = 'APP_BANNER_ENABLED';
const APP_BANNER_ENABLED_COOKIE_CHAT = 'APP_BANNER_ENABLED_CHAT';
const APP_BANNER_CLOSED_VALUE = 'closed';

interface PromoBanner {
  show: boolean;
  showInChat: boolean;
}

const promotionBannerSlice = createSlice({
  name: 'promotionBanner',
  initialState: {
    // Show only if App Promotion cookie is not set to "closed"
    show: Cookies.get(APP_BANNER_ENABLED_COOKIE) !== APP_BANNER_CLOSED_VALUE,
    showInChat: Cookies.get(APP_BANNER_ENABLED_COOKIE_CHAT) !== APP_BANNER_CLOSED_VALUE
  },
  reducers: {
    closePromotionBanner: {
      reducer: (state, action: PayloadAction<PromoBanner>) => {
        return action.payload;
      },
      prepare: ({ isChatRoute }) => {
        // Set a cookie to disable App Promotion Banner
        if (isChatRoute) {
          Cookies.set(APP_BANNER_ENABLED_COOKIE_CHAT, APP_BANNER_CLOSED_VALUE, { expires: 365 });
          Cookies.set(APP_BANNER_ENABLED_COOKIE, APP_BANNER_CLOSED_VALUE, { expires: 365 });
        } else {
          Cookies.set(APP_BANNER_ENABLED_COOKIE, APP_BANNER_CLOSED_VALUE, { expires: 365 });
        }

        return { payload: { show: false, showInChat: false } };
      }
    }
  }
});

export default promotionBannerSlice;
